import * as z from 'zod';
import { CURRENCY } from 'src/types';

export type BankAccountFormSchemaValues = z.infer<typeof bankAccountFormSchema>;
export const bankAccountFormSchema = z.object({
    name: z.string().nonempty(),
    iban: z.string().max(34).nonempty(),
    bic: z.string().max(12).nonempty(),
    currency: z.enum(CURRENCY),
    billing_entity: z.string().nonempty(),
    is_active: z.boolean(),
});
